var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"justify":"center"}},[_c('v-date-picker',{attrs:{"type":"month","multiple":""},model:{value:(_vm.months),callback:function ($$v) {_vm.months=$$v},expression:"months"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }